import { useContext, useState } from 'react'
import BaseMobileAppContainer from '../mobile/base-mobile-app-container/BaseMobileAppContainer'
import Styles from "./Hire.module.scss";
import { useDispatch } from 'react-redux'
import { APP_KEY_IDS } from '../../constants/constants'
import { closeWindow } from '../../actions'
import BaseNativeAppContainer from '../base-native-app-container/BaseNativeAppContainer';
import classnames from "classnames"
import MainCheckBox from '../maincheckbox/MainCheckBox';
import { child, getDatabase, ref, set } from 'firebase/database';
import { AuthContext } from '../../contexts/AuthContext';
import { ToastContext } from '../../contexts/toast/ToastContextProvider';
import { getDateTimeFromTimestamp } from '../../global/functions/functrions';
import { AppContext } from '../../contexts/AppContext';
// import CheckboxGroup from 'react_checkbox_group'



const ROLE_TYPES = [
    {
        id: "sde",
        label: "SDE"
    },
    {
        id: "android",
        label: "Android"
    },
    {
        id: "full_stack",
        label: "Full Stack"
    },
    {
        id: "desktop",
        label: "Desktop"
    },
    {
        id: "web_eveloper",
        label: "Web Developer"
    },
    {
        id: "aiml",
        label: "AI/ML"
    },
]


const POSITION_TYPES = [
    {
        id: "full_time",
        label: "Full Time"
    },
    {
        id: "part_time",
        label: "Part Time"
    },
    {
        id: "contract",
        label: "Contract"
    },
    {
        id: "internship",
        label: "Internship"
    },
    {
        id: "free_lance",
        label: "Free Lance"
    },
]


const Hire = () => {


    const {isMobile} = useContext(AppContext)

    return (
        <>
            {
                isMobile
                    ? <BaseMobileAppContainer
                        appId={APP_KEY_IDS.HIRE
                        }
                        title=''
                        MainScreen={<MainComponent />}
                        isMainScreenActive={true}
                    />
                    : <BaseNativeAppContainer
                        appId={APP_KEY_IDS.HIRE}
                        loadFromX={0}
                        title='Hire'
                        width={870}
                        height={628}
                        MainScreen={<MainComponent />}
                    />
            }
        </>
    )
}

export default Hire


const MainComponent = () => {

    const {userId,userName,isLoggedIn} = useContext(AuthContext)
    const {showToast} = useContext(ToastContext)

    const dispatch = useDispatch()

    const database = getDatabase();

    const [hireDetails,setHireDetails]=useState({
        name:"",
        position:"",
        message:"",
        role:"SDE",
        roletype:"Full Time"
    })

    const handleRole = (role: any) => {
        setHireDetails({
            ...hireDetails,
            role:role
        })
    }

    const handleRoleType = (roletype: any) => {
        setHireDetails({
            ...hireDetails,
            roletype:roletype
        })
    }

    const handleSubmit= async()=>{

        var message = ""

        if (userId) {

            if (hireDetails.message && hireDetails.position) {
        
                const dbRef = child(ref(database),`offers/${userId+"_"+(new Date())}`)
                set(dbRef, { 
                    ...hireDetails,
                    userName:userName,
                    userId:userId,
                    createdAt:getDateTimeFromTimestamp(Date.now())
                })
                dispatch(closeWindow(APP_KEY_IDS.HIRE))
                message="You offer has been delievered successfully. Thanks for the opportunity"
                dispatch(closeWindow(APP_KEY_IDS.FEEDBACK))
            }
            else {
                message="You have not enetered all the detailsYou have not enetered all the detailsYou have not enetered all the detailsYou have not enetered all the details"
            }

        }
        else {
            message="Kindly make sure you are logged in. Click here to login"
            dispatch(closeWindow(APP_KEY_IDS.FEEDBACK))
        }

        showToast({
            [`hire_${Date.now()}`]: {
                appId: APP_KEY_IDS.HIRE,
                appName: "Hire",
                bannerImage: "",
                mobileAppId: APP_KEY_IDS.MOBILE_FEEDBACK,
                subText: message,
                time: getDateTimeFromTimestamp(Date.now()),
                title: "Hiring Offer",
                visitLink: ""
            }
        })


    }


    return (
        <div className={classnames(Styles.hire,"glassBackground")}>
            <div className={Styles.hire_head}>Hire Me</div>
            <div className={Styles.hire_form}>

                <div className={Styles.inputs}>

                    <label className={Styles.hire_labels}>*Your Name</label>
                    <input type="text" value={hireDetails.name}  className={Styles.input_hire} id="p_name" placeholder='Enter your name' onChange={(e) => {setHireDetails({...hireDetails,name:e.target.value}) }} ></input>

                    <label className={Styles.hire_labels}>*Your Position</label>
                    <input type="text" value={hireDetails.position}  className={Styles.input_hire} id="position" placeholder='Enter your position' onChange={(e) => {setHireDetails({...hireDetails,position:e.target.value}) }} ></input>

                    <label className={Styles.hire_labels}>Contact/Message</label>
                    <textarea value={hireDetails.message}  className={classnames(Styles.input_hire, Styles.textarea)} placeholder="Add your contact information and anything you want me to know" onChange={(e) => {
                        setHireDetails({...hireDetails,message:e.target.value}) 
                     }} ></textarea><br />

                </div>

                <label className={Styles.hire_labels}>*Role</label>
                <div className={Styles.dev_type}>
                    {
                        ROLE_TYPES.map((option: any,index:number) => {
                            return (
                                    <MainCheckBox label={option.label} isChecked={hireDetails.role === option.label} onClick={() => handleRole(option.label)} key={`${option.label}_${index}}`}/> 
                            )
                        })
                    }
                </div>

                <label className={Styles.hire_labels}>*Role Type</label>
                <div className={Styles.dev_type}>
                    {
                        POSITION_TYPES.map((option: any) => {
                            return (
                                    <MainCheckBox label={option.label} isChecked={hireDetails.roletype === option.label} onClick={() => handleRoleType(option.label)} /> 
                            )
                        })
                    }
                </div>
                <div className={Styles.buttons}>
                    <button type='submit' className={Styles.ok} onClick={handleSubmit}>Ok</button>
                    <button className={Styles.cancel} onClick={() => { dispatch(closeWindow(APP_KEY_IDS.HIRE)) }}>Cancel</button>
                </div>
            </div>
        </div>

    )

}